module.exports = __webpack_public_path__ + "static/Apple iPhone 8 Space Grey-67495dfb83b44e122e48a4cb54098bd1.png";